var config = require('../config.js')
module.exports = {
	getBannerList: config.host + '/offical/api/v1/banner-config/list/c', //获取首页banner图
	// getBannerList: config.host + '/offical/api/v1/banner-config/list/v4/c', //获取首页banner图
	getScreenAdList: config.host + '/offical/api/v1/banner-config/screen-ad/list/c', //获取首页banner图
	// getScreenAdList: config.host + '/offical/api/v1/banner-config/screen-ad/list/v4/c', //获取首页banner图
	getShowTypeApi: config.host + '/tktbc/api/v1/cshow/getShowType/c', // 首页类型
	// getRecommendShowList: config.host + '/tktbc/api/v1/cshow/recommend/c', //获取演出推荐
	getRecommendShowList: config.host + '/tktbc/api/v1/cshow/recommend/v2/c', //获取演出推荐
	getRecommendShowList2: config.host + '/tktbc/api/v1/cshow/showRecommend/c', //获取演出推荐和标题合并优化
	// getRecommendShowList2: config.host + '/tktbc/api/v1/cshow/showRecommend/v4/c', //获取演出推荐和标题合并优化
	getPrepareSale: config.host + '/tktbc/api/v1/cshow/prepareSale/v2/c', //即将开售
	// getPrepareSale: config.host + '/tktbc/api/v1/cshow/prepareSale/v4/c', //即将开售
	getreVenueList: config.host + '/tktbc/api/v1/venue/recommend/c', //获取场馆
	// getNewsList: config.host + '/offical/api/v1/news/manage/getHomeNew/c', //获取新闻列表
	getNewsList: config.host + '/offical/api/v1/page/getHomePageNews/c', //获取新闻列表
	// getPageList: config.host + '/offical/api/v1/page/getHomePage/c', //获取文章列表
	getPageList: config.host + '/offical/api/v1/page/getHomePageNews/c', //获取文章列表
	getTitleList: config.host + '/offical/api/v1/title/list/c', //获取标题
	getTitleIndexList: config.host + '/offical/api/v1/title/list2/c', //获取首页标题
	dataEventTracking: config.host + '/datacenter/api/v1/event-tracking/c', //数据埋点

	pageListC: config.host + '/offical/api/v1/page/list/c', // 内容页面列表
	getHomeBalanceConfig: config.host + '/market/api/v1/balanceConfig/getConfig/c', // C端首页查询余额配置
	// getMallIsOpen: config.host + '/mallCenter/api/v1/address/isOpen/c', // C端首页查询商城
	getMallIsOpen: config.host + '/tktbc/api/v1/showindex/getTheaterBaseInfo/c', // C端首页查询商城
	
}
